<template>
    <div class="row">
        <div class="col-12">
            <card card-body-classes="table-full-width" no-footer-line>
                <div>
                    <div
                        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                    >
                        <h4 class="card-title text-purple">
                        {{ $t("app.modules.orders.tracking.name") }}
                        </h4>
                    </div>
                    <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div class="col-4">
                            {{ $t("app.modules.orders.headers.order_number") }}:
                            {{ this.item.numPedidoSAP }}
                        </div>
                        <div class="col-4">
                            {{ $t("app.modules.orders.headers.business_name") }}:
                            {{ this.item.cliente.razonSocial }}
                        </div>
                        <div class="col-4">
                            {{ $t("app.modules.orders.headers.delivery_date") }}:
                            {{ this.item.FechaEstimadaEntrega }}
                        </div>
                        <div class="col-4">
                            {{ $t("app.modules.orders.tracking.status") }}:
                            {{ this.item.idEstadoPedido }}
                        </div>
                        <div class="col-4">
                            {{ $t("app.modules.orders.tracking.destiny") }}:
                            {{ this.item.DestinoMercancia }}
                        </div>
                        <div class="col-4">
                            {{ $t("app.modules.orders.tracking.total") }}:
                            {{ this.item.Total | numFormat('0,0.00') }}
                        </div>
                    </div>
                    <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div class="col-4">
                            {{ $t("app.modules.orders.tracking.detail") }}:
                            <el-select
                            type="primary"
                            v-model="currPartida"
                            filterable
                            :placeholder="$t('app.modules.orders.tracking.detail')"
                            @change="getTracking"
                            >
                                <el-option label="" value="0"></el-option>
                                <el-option
                                    v-for="det in this.detalles"
                                    :key="det.idDetallePedido"
                                    :label="det.numPedidoSAP"
                                    :value="det.idDetallePedido"
                                >
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <time-line>
                            <time-line-item
                                inverted
                                badge-type="info"
                                badge-icon="now-ui-icons files_box"
                                v-for="(tra) in this.tracking"
                                :key="tra.idDetallePedido">
                                    <div slot="header" class="badge badge-info">
                                        {{ tra.fecha }}
                                    </div>
                                    <div slot="content">
                                        <div>{{ tra.fase_nombre }}</div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                    <div slot="footer">
                                        {{ tra.transporte_nombre }}
                                        &nbsp;|&nbsp;
                                        {{ tra.transportista_nombre }}
                                    </div>
                            </time-line-item>
                        </time-line>
                    </div>
                </div>
                <div
                    slot="footer"
                    class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                ></div>
            </card>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import TimeLine from "@/components/Timeline/TimeLine.vue"
import TimeLineItem from "@/components/Timeline/TimeLineItem.vue"
import numeral from 'numeral'
import numFormat from 'vue-filter-number-format'

Vue.filter('numFormat', numFormat(numeral))

export default {
    components: {
        TimeLine,
        TimeLineItem
    },
    data() {
        return{
            idPedido: 0,
            item: {
                numPedidoSAP: "",
                cliente: {
                    razonSocial: ""
                },
                FechaEstimadaEntrega: "1900-01-01",
                idEstadoPedido: 0,
                DestinoMercancia: "",
                Total: 0.0
            },
            detalles: {},
            tracking: [],
            currPartida: 0
        }
    },
    async created() {
         this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
            showConfirmButton: false
        });

        if (Object.entries(this.$route.params).length == 0) {
            //No hay datos redireccionarlo
        } else {
            this.idPedido = this.$route.params.idPedido;
            await this.getPedido();
        }

        this.$swal.close();
    },
    methods: {
        async getPedido() {
            const params = {
                id: parseInt(this.idPedido),
                claveIdioma: this.$store.state.lang,
                usuario: this.$store.state.user.idUsuario,
                idPedido: parseInt(this.idPedido)
            };
            await this.$http.post(route("Pedidos/detallePedidoById"), params).then(
                async response => {
                if (response.body.code === 200) {
                    this.item = response.body.pedido;
                    this.detalles = response.body.pedido.detalles
                    console.log(this.item)
                    console.log(this.detalles)
                } else {
                    console.log(response.body);
                    // this.processError(response.body)
                }
                },
                error => {
                console.error(error);
                // this.processError(error)
                }
            );
        },
        async getTracking() {
            const params = {
                id: this.currPartida,
                claveIdioma: this.$store.state.lang,
                usuario: 0
            };

            await this.$http.post(route("PartidaTracking/getTrackingPartida"), params).then(
                async response => {
                if (response.body.code === 200) {
                    this.tracking = response.body.tracking;
                } else {
                    console.log(response.body);
                    // this.processError(response.body)
                }
                },
                error => {
                console.error(error);
                // this.processError(error)
                }
            );
        }
    }
}
</script>
